import { createReducer } from '@reduxjs/toolkit';
import {
  receiveThreads,
  addThread,
  upVoteThread,
  downVoteThread,
  neutralVoteThread,
} from './action';

const threadReducer = createReducer([], (builder) => {
  builder
    .addCase(receiveThreads.type, (state, action) => {
      return action.payload.threads;
    })
    .addCase(addThread.type, (state, action) => {
      state.push(action.payload.thread);
    })
    .addCase(upVoteThread.type, (state, action) => {
      const { threadId, userId } = action.payload;
      const thread = state.find(({ id }) => id === threadId);
      thread.upVotesBy.push(userId);
      thread.downVotesBy = thread.downVotesBy.filter((id) => id !== userId);
    })
    .addCase(downVoteThread.type, (state, action) => {
      const { threadId, userId } = action.payload;
      const thread = state.find(({ id }) => id === threadId);
      thread.upVotesBy = thread.upVotesBy.filter((id) => id !== userId);
      thread.downVotesBy.push(userId);
    })
    .addCase(neutralVoteThread.type, (state, action) => {
      const { threadId, userId } = action.payload;
      const thread = state.find(({ id }) => id === threadId);
      thread.upVotesBy = thread.upVotesBy.filter((id) => id !== userId);
      thread.downVotesBy = thread.downVotesBy.filter((id) => id !== userId);
    });
});

export default threadReducer;
